import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const testimonials = [{
    text: 'Fue la primera vez en AÑOS que pude dormir toda la noche sin despertarme con ansiedad. Pensé que ya era normal vivir así. Me equivoqué.',
    author: 'Juliana A., 42 años, Buenos Aires'
  }, {
    text: 'Llego a casa estresada del trabajo todos los días. Pero después de 10 minutos con los pies en el agua siento como si me hubieran sacado 10 kilos de los hombros. Es increíble.',
    author: 'Fernanda R., 35 años, Rosario'
  }, {
    text: 'Uso los rituales antes de mis meditaciones y siento que mi energía se expande. Mi casa cambió. YO cambié. No puedo creer que algo tan simple sea tan poderoso.',
    author: 'Ricardo L., 38 años, Mendoza'
  }, {
    text: 'Estaba escéptica al principio. Pero después del Protocolo de 7 Días mi nivel de ansiedad bajó a la mitad. Lo medí con el Tracker. Tengo pruebas.',
    author: 'Carolina M., 29 años, Córdoba'
  }];
  return <section ref={ref} className="py-20 sm:py-32 bg-white" data-id="element-465">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-466">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-467">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2F4538] mb-6" data-id="element-468">
            Lo que dicen quienes ya lo probaron:
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-469">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#F5F0E8] p-8 sm:p-10 rounded-3xl relative border border-[#D4AF37]/20" data-id="element-470">
              <Quote className="absolute top-8 right-8 w-12 h-12 text-[#B4A7D6] opacity-10" data-id="element-471" />
              <div className="flex gap-1 mb-6" data-id="element-472">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-473" />)}
              </div>
              <p className="text-[#1a1a1a]/80 text-lg italic mb-8 leading-relaxed" data-id="element-474">
                "{testimonial.text}"
              </p>
              <p className="font-bold text-[#2F4538]" data-id="element-475">— {testimonial.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}